<template>
  <div>
    <v-dialog v-show="splitPayloadObject.length" v-model="openPayload" max-width="600" style="z-index:500">
      <v-card class="py-5 px-5">
        <v-card-title class="title primary justify-center white--text">
          <div>
            Callback object
          </div>
          <v-btn @click="openPayload = false" class="white--text close-icon" icon>
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="body-2 pt-5 secondary-color">
          <v-layout justify-end class="mb-4">
            <v-row class="justify-center">
              <v-btn @click="displayDataAs = 'pretty'" outlined class="theme-main-color">
                Pretty
              </v-btn>
              <v-btn @click="displayDataAs = 'raw'" outlined class="secondary-color ml-3">
                Raw
              </v-btn>
            </v-row>
          </v-layout>
          <div v-if="displayDataAs === 'pretty'">
            <prism-editor
              class="js-editor"
              :code="JSON.stringify(payloadObject, null, 4)"
              readonly
              language="javascript"
            />
          </div>
        <div v-if="displayDataAs === 'raw'">
          {{ payloadObject }}
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPayloadsDataModal.data" max-width="700">
      <v-card class="py-5 px-5">
        <v-card-title class="justify-center secondary white--text">
          <div class="title">
            Your callback data
          </div>
        </v-card-title>
        <v-card-text class="body-2 secondary-color py-5">
          <div @click="openPayloadMethod(obj.payload)" class="object-type" :key="obj.id" v-for="obj in getCallbackObjects">
            <span class="subheading black--text primary--text text--darken-2">
              Event: {{ obj.type }}
              <v-icon class="pl-4">mdi-open-in-new</v-icon>
            </span>
            <span class="pl-5">({{ obj.index }})</span>
            <span v-if="obj.index === 1" class="pl-5 primary--text text--darken-1">LATEST</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrismEditor from 'vue-prism-editor'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: 'Js-api-payload-model',
  props: {
    showPayloadsDataModal: { type: [ Function, Boolean, Object ], required: true },
    callbackObjects: { type: Array, required: true }
  },
  components: {
    PrismEditor
  },
  data: () => ({
    displayDataAs: 'pretty',
    openPayload: false,
    payloadObject: {}
  }),
  computed: {
    getCallbackObjects () {
      const reversed = [ ...this.callbackObjects ].reverse()
      reversed.forEach((val, i) => { val.index = (i + 1) })
      return reversed
    },
    splitPayloadObject () {
      if (!Object.keys(this.payloadObject).length) return []
      // const payloadAsStr = JSON.stringify(this.payloadObject).replace(/{/, '').replace(/}/, '')
      const payloadAsStr = JSON.stringify(this.payloadObject, null, 4)
      return payloadAsStr.split(',')
    }
  },
  methods: {
    openPayloadMethod (payload) {
      const clone = { ...payload }
      delete clone.parentPaymentMethod
      delete clone.accounts
      delete clone.txTypeInput
      this.payloadObject = clone
      this.openPayload = true
    }
  }
}
</script>

<style lang="scss" scoped>
.object-type {
  background: #f1f1f1;
  padding: 10px;
  margin-top: 10px;
  font-weight: bold;
  cursor: pointer;
}
.close-icon {
  position: absolute;
  top: 25px;
  right: 25px;
}
</style>
